/**
 * Created by evgeny on 31.07.2024
 */

const ThrowawayView = function (throwaway, unitView) {
    this.throwaway = throwaway;
    this.unitView = unitView;

    this.throwaway.onAnimateDestroy = this.animateDestroy.bind(this);
};

ThrowawayView.prototype.animateDestroy = function (callback) {
    const sprite = this.unitView.sprite;

    if (sprite && sprite.hasAnimation("clean") && sprite.hasAnimation("hide")) {
        new ActionPlayer([
            function (f) {
                sprite.setAnimation(0, "clean", false);
                sprite.setCompleteListener(f);
            },

            function (f) {
                sprite.setAnimation(0, "hide", false);
                sprite.setCompleteListener(f);
            }
        ]).play(callback);
    } else {
        callback = cleverapps.wait(2, callback);
        this.unitView.addUpgradeAnimation(callback);
        sprite.runAction(StandartAnimations.disappear(sprite)).setFinalize(callback);
    }
};
